import React from 'react';
import { Box, IconButton, Tooltip } from '@mui/material';
import CloudDownloadIcon from '@mui/icons-material/CloudDownload';
import DeleteIcon from '@mui/icons-material/Delete';

/**
 * Action buttons for each row in the Export History grid.
 *
 * cellRendererParams:
 *   onDownload  – opens the export file URL
 *   onDelete    – opens the delete confirmation dialog
 */
const BackupActionsCallRenderer = (props) => {
  const { onDownload, onDelete } = props;

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
      <Tooltip title="Download export" placement="top" arrow>
        <IconButton size="small" onClick={() => onDownload?.(props)}>
          <CloudDownloadIcon fontSize="small" color="success" />
        </IconButton>
      </Tooltip>

      <Tooltip title="Delete record" placement="top" arrow>
        <IconButton size="small" onClick={() => onDelete?.(props)}>
          <DeleteIcon fontSize="small" color="error" />
        </IconButton>
      </Tooltip>
    </Box>
  );
};

export default BackupActionsCallRenderer;
